import { Button as ChakraButton } from "@chakra-ui/react";
import { ButtonProps } from "./Button.types";
import "./Button.css";
import { FC } from "react";
import Icon from "../Icon";

const Button: FC<ButtonProps> = ({
  variant,
  iconLeft,
  iconRight,
  isDisabled,
  children,
  type,
  bgColor,
  onClick,
  onSubmit,
  ref,
  ...rest
}) => {
  return (
    <ChakraButton
      className="button"
      {...rest}
      data-button-variant={variant}
      isDisabled={isDisabled}
      data-button-color={bgColor}
      spinner={<Icon name="spinner" className={"loadingSpinner"} size={5} />}
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      onSubmit={onSubmit}
      pos={"relative"}
      ref={ref}
    >
      {iconLeft && iconLeft}

      {children}

      {iconRight && iconRight}
    </ChakraButton>
  );
};

export default Button;
